import React, { useEffect } from "react";
import { useTranslation, Trans} from "react-i18next";
import basket from "../assets/images/basket.png";
import guarantee from "../assets/images/guarantee.png";
import {triggerFadeInOnScroll3} from "../assets/js/swithalert";
import config from "../config";
import Breadcrumb from "../components/Breadcrumb";


function SelfDry() {

  const {t} = useTranslation();

  useEffect(() => {
    triggerFadeInOnScroll3();
  }, []);

  return (
    <div className="main">
        <div class="section_selfdry_laundry" data-aos="">
            <Breadcrumb />
            <div class="containers"> 
                <div class="row g-sm-5">
                    <div class="col-md-8 px-4 px-sm-5">
                        <div class="subtitle">
                            <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4 fade-in2">
                                <span class="bar"></span>
                                <span class="bar"></span>
                                <span class="bar"></span>
                                <span class="bar"></span>
                            </div>           
                            <h2 class="fade-in2">{t("selfdry_laundry_title")}</h2>
                        </div> 
                        <div class="content">
                            <p class="text-center pt-4 fade-in2 p1"> 
                                <Trans i18nKey="selfdry_laundry_content_1" 
                                    values={{ brand: config.brand}}>
                                </Trans>
                            </p>
                            <h3 class="text-start">{t("selfdry_laundry_content_subtitle")}</h3>
                            <ul class="list list-icons list-icons-style-3 text-start">
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_laundry_content_2"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_laundry_content_3"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_laundry_content_4"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_laundry_content_5"></Trans></small></li>
                            </ul>
                            <p class="text-center py-4 p2"><Trans i18nKey="selfdry_laundry_content_6"></Trans></p>
                            <div class="row">
                                <p class="text-center try_garentee">
                                    <img src={basket} class="" style={{"max-width":"64px"}}/>
                                    <Trans i18nKey="try_garentee_text"></Trans>
                                    <img src={guarantee} class="pb-2" style={{"max-width":"51px", "padding-left":"6px"}}/>
                                </p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" section_selfdry_why" data-aos="">
            <div class="subtitle">
                <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                </div>           
                <h2 class=""><Trans i18nKey="selfdry_why_title" values={{ brand: config.brand}}></Trans></h2>
            </div> 
            <div class="content">
                <p class="text-center py-4"><Trans i18nKey="selfdry_why_content" values={{ brand: config.brand}}></Trans></p>
                <div class="row gy-5 g-sm-4 g-xl-5">
                    <div class="col-md-6 left text-start">
                        <div class="carding p-3 p-md-2 p-lg-3">
                            <h3 class="text-start"><Trans i18nKey="selfdry_why_left_subtitle_1"></Trans></h3>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfdry_why_left_subtitle_2")}</h4>
                            <p><Trans i18nKey="selfdry_why_left_text_1"></Trans></p>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfdry_why_left_subtitle_3")}</h4>
                            <p>
                                <Trans i18nKey="selfdry_why_left_text_2"></Trans>
                            </p>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfdry_why_left_subtitle_4")}</h4>
                            <p><Trans i18nKey="selfdry_why_left_text_3"></Trans></p>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfdry_why_left_text_4")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfdry_why_left_text_5")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfdry_why_left_text_6")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfdry_why_left_text_7")}</strong></small></li>
                            </ul>
                            <h4 class="mb-sm-4 mb-3">{t("selfdry_why_left_subtitle_5")}</h4>
                            <p><Trans i18nKey="selfdry_why_left_text_8"></Trans></p>
                        </div>
                    </div>
                    <div class="col-md-6 right text-start">
                        <div class="carding p-3 p-md-2 p-lg-3">
                            <h3 class="text-start"><Trans i18nKey="selfdry_why_right_subtitle_1" values={{ brand: config.brand}}></Trans></h3>
                            <p><Trans i18nKey="selfdry_why_right_text_1"></Trans></p>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfdry_why_right_subtitle_2")}</h4>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_why_right_text_2"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_why_right_text_3"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfdry_why_right_text_4"></Trans></small></li>
                            </ul>

                            <p class="text-start">
                                 <Trans i18nKey="selfdry_why_right_text_5" values={{ brand: config.brand}}></Trans>
                            </p>
                        </div>
                    </div>
                </div>
                    <div class="row mt-4">
                        
                        <p class="text-center try_garentee mb-0">
                            <img src={basket} class="" style={{"max-width":"64px"}}/>
                            <Trans i18nKey="try_garentee_text"></Trans>
                            <img src={guarantee} class="pb-2" style={{"max-width":"51px", "padding-left":"6px"}}/>
                        </p>
            
                    </div>
                
            </div>
        </div>
      
    </div>
  );
}

export default SelfDry;
